import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { Subscription } from 'rxjs';
import { AppConstants } from '../../../utils/AppConstants';
import { AppEnums, InspectionProviders } from '../../../models/AppEnums';
import { ANPRInspectionConfigAuth, InspectionConfigBaseAuth, InspectionConfiguration, InspectionConfigurationDetail } from '../../../models/InspectionConfiguration';
import { InspectionConfigurationService } from '../../../services/inspection-configuration.service';
import { BaseAuthConfigsComponent } from "../base-auth-configs/base-auth-configs.component";
import { AlertService } from '../../shared/alert/alert.service';
import { ANPRAuthConfigsComponent } from '../anpr-auth-configs/anpr-auth-configs.component';

@Component({
  selector: 'app-inspection-provider-detail',
  standalone: true,
  imports: [
    CommonModule,
    HasPermissionDirective,
    ConfirmAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    BaseAuthConfigsComponent,
    ANPRAuthConfigsComponent],
  templateUrl: './inspection-provider-detail.component.html',
  styleUrl: './inspection-provider-detail.component.scss',
})
export class InspectionProviderDetailComponent implements OnInit, OnDestroy {

  paramSubscription!: Subscription;
  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';

  id?: number;
  inspectionConfiguration: InspectionConfigurationDetail = { active: true };
  inspectionAuth: 'InspectionConfigBaseAuth' | 'ANPRInspectionConfigAuth' | undefined;
  detail_title: string = 'Nuova configurazione';

  inspectionProvidersTypes = AppEnums.inspectionProviders
  constructor(
    private inspectionConfigurationService: InspectionConfigurationService,
    private alertService: AlertService,
    private fullSpinnerService: FullSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    fullSpinnerService.spinner(undefined);
  }
  ngOnInit(): void {

    this.paramSubscription = this.activatedRoute.params.subscribe(parameter => {
      this.id = parameter['id'];
      if (this.id! > 0) {
        this.fullSpinnerService.spinner('');
        this.inspectionConfigurationService.get(this.id!).subscribe({
          next: (res) => {
            this.inspectionConfiguration = res;
            this.inspectionConfiguration.auth = JSON.parse(res.configs!);

            if (res.provider == InspectionProviders.MCTC ||
              res.provider == InspectionProviders.FLOWBIRD ||
              res.provider == InspectionProviders.EASY_PARK ||
              res.provider == InspectionProviders.PARK_MANAGER
            ) {
              this.inspectionConfiguration = this.inspectionConfiguration as InspectionConfigurationDetail<InspectionConfigBaseAuth>;
              this.inspectionAuth = 'InspectionConfigBaseAuth'
            }
            else if (res.provider == InspectionProviders.ANPR) {
              this.inspectionConfiguration = this.inspectionConfiguration as InspectionConfigurationDetail<ANPRInspectionConfigAuth>;
              this.inspectionAuth = 'ANPRInspectionConfigAuth'
            }

            this.detail_title = res.provider!;
          }, complete: () => {
            this.fullSpinnerService.spinner(undefined);
          }
          , error: () => {
            this.fullSpinnerService.spinner(undefined);
          }
        });
      }
    });
  }
  onSubmit(loginForm: NgForm): void {
    if (loginForm.valid) {
      this.fullSpinnerService.spinner('');
      this.inspectionConfiguration.configs = JSON.stringify(this.inspectionConfiguration.auth);
      this.inspectionConfigurationService.save(this.inspectionConfiguration).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
          this.router.navigate(['inspections-config']);
        }, complete: () => {
          this.fullSpinnerService.spinner(undefined);
        }
        , error: () => {
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }

  back() {
    this.router.navigate(['inspections-config']);
  }

  confirmDelete() {
    this.showConfirmationModal = true;
    this.confirmationMessage = "Sicuro di voler eliminare la configurazione " + this.inspectionConfiguration.provider + ' ?';
  }

  cancelDelete() {
    this.showConfirmationModal = false;
  }

  delete() {
    this.fullSpinnerService.spinner('');
    this.inspectionConfigurationService.delete(this.inspectionConfiguration.id!).subscribe({
      next: (res) => {
        this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
        this.router.navigate(['inspections-config']);
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  onProviderChange() {
    if (this.inspectionConfiguration.provider == InspectionProviders.MCTC ||
      this.inspectionConfiguration.provider == InspectionProviders.FLOWBIRD ||
      this.inspectionConfiguration.provider == InspectionProviders.EASY_PARK ||
      this.inspectionConfiguration.provider == InspectionProviders.PARK_MANAGER
    ) {
      this.inspectionConfiguration.auth = {}
      this.inspectionConfiguration = this.inspectionConfiguration as InspectionConfigurationDetail<InspectionConfigBaseAuth>;
      this.inspectionAuth = 'InspectionConfigBaseAuth'
    }

  }

  get authConfigBaseAuth(): InspectionConfigBaseAuth {
    return this.inspectionConfiguration.auth as InspectionConfigBaseAuth;
  }

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }
}



